/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { memo, useCallback, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Row, Col } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CustomInputWithController } from "../../Core/Components/CustomInput";
import Button from "../../Core/Components/CustomButton";
import BlockedEyeIcon from "../../Common/Svgs/BlockedEyeIcon";
import { updateTenants } from "../../Redux/Slices/tenants.slice";
import { updateLoggedInUser } from "../../Redux/Slices/loggedInUser.slice";
import ToastMessageModal from "./ToastMessageModal";

// validations
const validationForName = {
  required: "Required.",
};

const validationForPassword = {
  required: "please enter password",
  minLength: {
    value: 8,
    message: "less characters for password",
  },
};

const TenantSignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const { handleSubmit, control, formState, getValues } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
    },
  });

  const localPassword = getValues("password");
  const localConfirmPassword = getValues("confirmPassword");

  const [tenantEmail, setTenantEmail] = useState("");
  const [focus, setFocus] = useState({
    firstName: false,
    lastName: false,
    password: false,
    confirmPassword: false,
  });
  const [showIcon, setShowIcon] = useState({
    password: false,
    confirmPassword: false,
  });

  const [toast, setToast] = useState({
    visible: false,
    title: "",
    description: "",
  });

  // const checkTenantStatus = useCallback(async () => {
  //   try {
  //     dispatch(
  //       updateTenants({
  //         key: "loading",
  //         value: true,
  //       }),
  //     );

  //     const token = searchParams.get("token");
  //     const decoded = jwtDecode(token);

  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/tenant/check-tenant-status`,
  //       {
  //         params: {
  //           tenantId: decoded.tenantId,
  //         },
  //       },
  //     );

  //     const { isActive, verificationComplete } = response.data.tenant;

  //     // tenant is either deleted or paused -> redirect to no path
  //     if (isActive == 0 || isActive == 2) {
  //       navigate({
  //         pathname: "/no-path",
  //         search: "?noRedirect=true",
  //       });
  //     }

  //     // tenant is already onboarded i.e. is_active = 1 & verification_complete = 1 -> redirect to no path
  //     if (isActive == 1 && verificationComplete == 1) {
  //       navigate({
  //         pathname: "/no-path",
  //         search: "?noRedirect=true",
  //       });
  //     }

  //     // if (response.data.status == 1) {
  //     //   navigate({
  //     //     pathname: "/no-path",
  //     //     search: "?noRedirect=true",
  //     //   });
  //     // }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     dispatch(
  //       updateTenants({
  //         key: "loading",
  //         value: false,
  //       }),
  //     );
  //   }
  // }, [dispatch, navigate, searchParams]);

  const verifyToken = useCallback(() => {
    const token = searchParams.get("token");
    const decoded = jwtDecode(token);

    localStorage.setItem("tenantId", decoded.tenantId);

    const expiry = decoded.exp * 1000;
    const current = new Date();

    if (expiry < current.getTime()) {
      navigate("/invitation-expired");
    } else {
      setTenantEmail(decoded.email);
    }
  }, [navigate, searchParams]);

  const onSubmit = async (e) => {
    const token = searchParams.get("token");

    const payload = {
      firstName: e.firstName,
      lastName: e.lastName,
      email: tenantEmail,
      password: e.password,
      confirmPassword: e.confirmPassword,
      token,
    };

    try {
      dispatch(
        updateTenants({
          key: "loading",
          value: true,
        }),
      );

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/tenant/tenant-user`,
        payload,
      );

      if (response.status === 200) {
        localStorage.clear();

        const { message, token: newToken, ...rest } = response.data;

        localStorage.setItem("token", newToken);
        dispatch(updateLoggedInUser({ key: "userDetails", value: rest }));
        navigate("/onboarding");
      }
    } catch (error) {
      const message = error?.response?.data?.message || "";

      if (message) {
        setToast({
          visible: true,
          title: error?.response?.data?.title || "",
          description: error?.response?.data?.description || "",
        });
      }

      // const message = error?.response?.
    } finally {
      dispatch(
        updateTenants({
          key: "loading",
          value: false,
        }),
      );
    }
  };

  // verifying the token
  useEffect(() => {
    if (searchParams.has("token")) verifyToken();
  }, [searchParams, verifyToken]);

  // to find if the tenant is already onboarded or no
  // useEffect(() => {
  //   if (searchParams.has("token")) checkTenantStatus();
  // }, [searchParams, checkTenantStatus]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (toast?.visible) {
        setToast({ visible: false, title: "", description: "" });
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, [toast]);

  return (
    <div className="w-screen h-screen">
      <Row className="h-full">
        <Col span={15} className="h-full overflow-hidden">
          <img
            src="/assets/images/Login/login-image-new.png"
            alt="LoginImage"
            className="object-cover w-full h-full"
          />
        </Col>

        <Col span={9}>
          <div className="flex flex-col items-center justify-center w-full h-full gap-y-6 bg-background-white">
            <img
              src="/assets/songa-main-logo.svg"
              alt="Songa Mobility"
              className="w-[258px] h-14"
            />

            <div>
              <p className="font-poppins text-base font-medium text-center capitalize">
                Let’s get you started!
              </p>

              <p className="mt-2 font-poppins text-xs font-light text-center text-dark-gray">
                Please create your account.
              </p>
            </div>

            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col items-center justify-center w-full gap-y-6"
            >
              <CustomInputWithController
                intent="login"
                control={control}
                formState={formState}
                focus={focus.firstName}
                setFocus={(e) => setFocus({ ...focus, firstName: e })}
                name="firstName"
                placeholder="Enter Your First Name"
                rules={validationForName}
              />

              <CustomInputWithController
                intent="login"
                control={control}
                formState={formState}
                focus={focus.lastName}
                setFocus={(e) => setFocus({ ...focus, lastName: e })}
                name="lastName"
                placeholder="Enter Your Last Name"
                rules={validationForName}
              />

              <div className="h-9 w-[312px] bg-background border border-light-grey rounded-md py-2 px-4 cursor-not-allowed">
                <p className="font-aileron text-xs font-normal text-dark-gray">
                  {tenantEmail}
                </p>
              </div>

              <CustomInputWithController
                inputType={showIcon.password ? "text" : "password"}
                intent="login"
                control={control}
                formState={formState}
                focus={focus.password}
                setFocus={(e) => setFocus({ ...focus, password: e })}
                name="password"
                placeholder="Set Password"
                rules={validationForPassword}
                suffix={
                  <button
                    type="button"
                    onClick={() => {
                      if (localPassword) {
                        setShowIcon((e) => ({ ...e, password: !e.password }));
                      }
                    }}
                    disabled={!localPassword}
                  >
                    {showIcon.password ? (
                      <img src="/images/eye.png" className="w-5 h-5" alt="" />
                    ) : (
                      <BlockedEyeIcon
                        className={
                          localPassword ? "text-black" : "text-dark-gray"
                        }
                      />
                    )}
                  </button>
                }
              />

              <CustomInputWithController
                inputType={showIcon.confirmPassword ? "text" : "password"}
                intent="login"
                control={control}
                formState={formState}
                focus={focus.confirmPassword}
                setFocus={(e) => setFocus({ ...focus, confirmPassword: e })}
                name="confirmPassword"
                placeholder="Confirm Password"
                rules={validationForPassword}
                suffix={
                  <button
                    type="button"
                    onClick={() => {
                      if (localConfirmPassword) {
                        setShowIcon((e) => ({
                          ...e,
                          confirmPassword: !e.confirmPassword,
                        }));
                      }
                    }}
                    disabled={!localConfirmPassword}
                  >
                    {showIcon.confirmPassword ? (
                      <img src="/images/eye.png" className="w-5 h-5" alt="" />
                    ) : (
                      <BlockedEyeIcon
                        className={
                          localConfirmPassword ? "text-black" : "text-dark-gray"
                        }
                      />
                    )}
                  </button>
                }
              />

              <Button type="submit" width="login">
                Sign Up
              </Button>
            </form>
          </div>
        </Col>
      </Row>

      {toast?.visible && (
        <ToastMessageModal
          visible={toast?.visible}
          title={toast?.title}
          description={toast?.description}
          onCancel={() =>
            setToast({ visible: false, title: "", description: "" })
          }
        />
      )}
    </div>
  );
};
export default memo(TenantSignUp);
